import {
  Box,
  Button,
  ErrorIcon,
  Heading,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';
import PropTypes from 'prop-types';
import PropsType from 'props-type';

const propTypes = {
  errorMessage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

type DocumentDownloadErrorModalProps = PropsType<typeof propTypes>;

export default function DocumentDownloadErrorModal({
  title,
  errorMessage,
  onConfirm,
}: DocumentDownloadErrorModalProps) {
  return (
    <Modal isOpen maxWidth="xs" onClose={onConfirm}>
      <ModalTitle>
        <ErrorIcon />
      </ModalTitle>
      <ModalContent>
        <Heading fontSize="sm" mb={6} textAlign="center">
          {title}
        </Heading>
        <Box
          bg="boxBackgroundNeutralBase"
          borderColor="boxBorderNeutralBase"
          borderStyle="solid"
          borderWidth="1px"
          px={6}
          py={7}
        >
          <Text> {errorMessage}</Text>
        </Box>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onConfirm}>확인</Button>
      </ModalFooter>
    </Modal>
  );
}
